import { useTranslation } from 'react-i18next';
import type { BackendUser } from '../../../services/user/userService';
import { useRestaurantStore } from '../../../stores/appRestaurantStore';
import { borderGrey, cardBg, primaryText, secondaryText } from '../../../styling/stylingHelper';

/** Linked demo sessions may browse their assigned restaurants, never administer an account. */
export default function DemoProfile({ profile, onLogout }: { profile: BackendUser; onLogout: () => Promise<void> }) {
  const { t } = useTranslation();
  const restaurants = useRestaurantStore(state => state.restaurants);
  return <main className={`mx-auto max-w-3xl space-y-6 p-4 sm:p-6 ${primaryText}`}>
    <h1 className="text-2xl font-semibold">{t('profile.title')}</h1>
    <section className={`space-y-4 rounded-2xl border p-5 sm:p-6 ${borderGrey} ${cardBg}`}>
      {profile.name && <p className="break-words text-lg font-medium">{profile.name}</p>}
      <dl>
        <dt className={`text-sm ${secondaryText}`}>{t('profile.email')}</dt>
        <dd className="break-all">{profile.email}</dd>
      </dl>
      <button type="button" onClick={() => void onLogout()} className={`min-h-[44px] rounded-lg border px-4 py-2 ${borderGrey}`}>{t('profile.logout')}</button>
    </section>
    <section className={`rounded-2xl border p-5 sm:p-6 ${borderGrey} ${cardBg}`}>
      <h2 className="mb-3 text-lg font-semibold">{t('profile.yourRestaurants')}</h2>
      <ul className="space-y-2">{restaurants.map(restaurant => <li key={restaurant.id} className="break-words">{restaurant.name}</li>)}</ul>
    </section>
  </main>;
}
